export default {"src":"/_next/static/media/playoff-pair-penalty.e911ec66.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};